// extracted by mini-css-extract-plugin
export var chevronIcon = "_c5-2";
export var teamName = "_c5-1";
export var teamSwitcherButton = "_c5-0";